<template>
    <project-step-container
            prev-to="be_deep_customer_empathy_5"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row class="first-form">
            <b-col cols="12" class="mb-4 simple-text" tabindex="0">
                 {{getMessage(6, 'empathy-map-sub')}}
            </b-col>
        </b-row>
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(6, 'empathy-map-guide')" ></LinkStyleGuide>
       <b-row class="mt-3 text-center">
            <b-col cols="6" class="emotion-content pr-2" :key="index" v-for="(emotion, index) in emotions">
                <b-button block size="lg" class="square" v-bind:class="{ active: form.emotion.key === emotion.key, isCareerEntrep: isJACareerEntrepreApp }"
                    v-on:click="select(emotion.key)">
                    <span >{{ emotion.value }}</span>
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3" v-if="showOther">
                <label for="other-emotion" class="other-emotion">Other emotion</label>
                <input id="other-emotion" type="text" v-model="form.otherEmotion"/>
            </b-col>
        </b-row>
        <NoNegativeEmotionPopUp></NoNegativeEmotionPopUp>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import Steps from "../Utils/steps";
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import NoNegativeEmotionPopUp from "../Components/NoNegativeEmotionPopUp"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    const Emotions = Object.freeze({
        FRUSTRATED: 0,
        WORRIED: 1,
        STRESSED: 2,
        IRRITATED: 3,
        CONFUSED: 4,
        AFRAID: 5,
        SAD: 6,
        NONEGATIVEEMOTION:7,
        OTHER: 8
    })

    export default {
        name: "DeepCustomerEmpathy6",
        components: {ProjectStepContainer , NoNegativeEmotionPopUp , LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_EMOTION,
                urlNextProject:'be_deep_customer_empathy_7',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.FOLLOW_ME_HOME_GUIDE),
                form: {
                    emotion: {},
                    otherEmotion: ""
                },
                emotions: [
                    {"key": 0, "value": "Frustrated"},
                    {"key": 1, "value": "Worried"},
                    {"key": 2, "value": "Stressed"},
                    {"key": 3, "value": "Irritated"},
                    {"key": 4, "value": "Confused"},
                    {"key": 5, "value": "Afraid"},
                    {"key": 6, "value": "Sad"},
                    {"key": 7, "value": "No Negative Emotion"},
                    {"key": 8, "value": "Other"}
                ],
                showOther: false
            }
        },
        created() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
            this.showOther = this.form.emotion.key === 8
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            select(num) {
                const form = this.form
                form.emotion = this.emotions.filter((e, idx) => e.key == num)[0];
                this.showOther = num === 8
                if(num === 7 ) {
                   this.$bvModal.show('no-negative-emotion-pop-up')

                }
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .font-size
        .square
           word-break break-all
           padding-right: 0px;
           padding-left: 0px;
    +for_breakpoint(xs)
        .font-size
            .emotion-content
                padding-right: 2px !important
                padding-left: 2px !important
        .first-form
            margin-top -10px
    .high-contrast
        .square
            border 1px solid  color-4
            box-shadow(0px 1px 5px color-16)
            color black
            &:hover
                border solid 1px color-29

            &.active
                background-color color-29
                color white
    .other-emotion
        font font-sourcesans-bold
        font-size 14px
        color black

    .square
        font-family 'Source Sans Pro', sans-serif
        font-size 16px
        font-weight 400
        color color-4
        border-radius 10px
        box-shadow(0px 1px 5px color-16)
        height 69px
        margin-top 15px

        &:hover
            border solid 1px color-5

        &.active
            background-color color-5
            color white

    .table-t
        display table
        height 69px
        width 100%

    .text-t
        display table-cell
        vertical-align middle
</style>
